// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-traditional-card-container {
  min-width: 375px;
  width: 100%;
  border-top: 2px solid #002129;
  border-bottom: 2px solid #002129;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-top: 40px;
  max-width: 550px !important; /* Removed quotes */
  margin: 0 auto; /* Removed quotes */
  margin-bottom: 40px;
}
@media (min-width: 560px) {
  .super-pickem-traditional-card-container {
    border: 2px solid #002129;
  }
}

.super-pickem-traditional-teams-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start;
  justify-content: center;
  width: 60%;
}

.super-pickem-traditional-teams {
  height: 36px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 4px;
  width: 100%;
}

.super-pickem-traditional-at-symbol-container {
  height: 14px;
  display: flex;
  align-items: center;
  width: 100%;
}

.super-pickem-traditional-header-date {
  color: #FFF;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 150% !important;
  letter-spacing: 0px !important;
  font-size: clamp(12px, 2vw, 16px) !important;
}
@media (min-width: 768px) {
  .super-pickem-traditional-header-date {
    font-size: 16px !important;
  }
}

.super-pickem-traditional-header-bet-types {
  color: #FFF !important;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 150% !important;
  letter-spacing: 0px !important;
  font-size: clamp(12px, 2vw, 16px) !important; /* Responsive font size */
  flex: 1 1 !important;
  text-align: center !important;
}
@media (min-width: 768px) {
  .super-pickem-traditional-header-bet-types {
    font-size: 16px !important; /* Lock font size at 16px when screen width is 768px or more */
  }
}

.super-pickem-traditional-team-logo {
  width: clamp(20px, 4vw, 28px) !important;
  height: clamp(20px, 4vw, 28px) !important;
  object-fit: contain !important;
}

.super-pickem-traditional-team-name {
  color: #002129 !important;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: clamp(10px, 3vw, 16px) !important;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
@media (min-width: 768px) {
  .super-pickem-traditional-team-name {
    font-size: 16px !important;
  }
}

.super-pickem-traditional-team-score {
  text-align: right;
  font-size: 18px !important;
  font-weight: 700 !important;
}

.super-pickem-traditional-at-symbol {
  color: #002129 !important;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 800 !important;
  font-size: clamp(12px, 2vw, 14px) !important;
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.super-pickem-traditional-bet-buttons-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 40%;
}

.super-pickem-traditional-bet-button {
  height: 40px !important;
  width: 100% !important;
  font-size: clamp(12px, 2vw, 14px) !important;
  white-space: pre-line !important;
  line-height: 1.2 !important;
  border: 1px solid #002129 !important;
  background-color: white !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.super-pickem-traditional-bet-button span {
  display: inline-flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 3px !important;
}
@media (min-width: 600px) {
  .super-pickem-traditional-bet-button {
    white-space: nowrap !important;
    line-height: normal !important;
    flex-direction: row !important;
  }
}
.super-pickem-traditional-bet-button.active {
  background-color: rgba(0, 170, 209, 0.2) !important;
  color: white !important;
  border: 1px solid #00AAD1 !important;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2) !important;
}
.super-pickem-traditional-bet-button.inactive {
  background-color: #fff !important;
  color: #fff !important;
  border: 1px solid #fff !important;
}
.super-pickem-traditional-bet-button.locked {
  background-color: #002129 !important;
  color: #fff !important;
  border: 1px solid #002129 !important;
}
.super-pickem-traditional-bet-button.winner {
  background-color: #CCFFEF !important;
  color: #fff !important;
  border: 1px solid #00AA72 !important;
}
.super-pickem-traditional-bet-button.loser {
  background-color: rgba(204, 41, 60, 0.2) !important;
  color: #fff !important;
  border: 1px solid #CC293C !important;
}
.super-pickem-traditional-bet-button.push {
  background-color: #5A5B5C !important;
  color: #fff !important;
  border: 1px solid #000000 !important;
}
.super-pickem-traditional-bet-button.not-chosen {
  background-color: #fff !important;
  color: rgba(0, 33, 41, 0.5019607843) !important;
  border: 1px solid rgba(0, 33, 41, 0.5019607843) !important;
}

.super-pickem-traditional-bet-button-text1 {
  color: #002129 !important;
  white-space: nowrap !important;
  background-color: transparent !important;
}
.super-pickem-traditional-bet-button-text1.active {
  color: #002129 !important;
}
.super-pickem-traditional-bet-button-text1.inactive {
  color: #fff !important;
}
.super-pickem-traditional-bet-button-text1.locked {
  color: #fff !important;
}
.super-pickem-traditional-bet-button-text1.winner {
  color: #002129 !important;
}
.super-pickem-traditional-bet-button-text1.loser {
  color: #002129 !important;
}
.super-pickem-traditional-bet-button-text1.push {
  color: #fff !important;
}
.super-pickem-traditional-bet-button-text1.not-chosen {
  color: rgba(0, 33, 41, 0.5019607843) !important;
}

.super-pickem-traditional-bet-button-text2 {
  color: #00AAD1 !important;
  white-space: nowrap !important;
}

.super-pickem-traditional-button-pair {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/SuperPickemComponents/SuperPickemTwoPickCard.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,WAAA;EACA,6BAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA,EAAA,mBAAA;EACA,cAAA,EAAA,mBAAA;EACA,mBAAA;AACJ;AACI;EAhBJ;IAiBQ,yBAAA;EAEN;AACF;;AAEA;EACI,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AAGA;EACI,WAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,4CAAA;AAAJ;AAEI;EATJ;IAUQ,0BAAA;EACN;AACF;;AAEA;EACI,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,4CAAA,EAAA,yBAAA;EACA,oBAAA;EACA,6BAAA;AACJ;AACI;EAXJ;IAYQ,0BAAA,EAAA,8DAAA;EAEN;AACF;;AAEA;EACI,wCAAA;EACA,yCAAA;EACA,8BAAA;AACJ;;AAGA;EACI,yBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EAEA,4CAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;AAEI;EAbJ;IAcQ,0BAAA;EACN;AACF;;AAEA;EACI,iBAAA;EACA,0BAAA;EACA,2BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4CAAA;EACA,2BAAA;EACA,4BAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AACJ;;AAEA;EACI,uBAAA;EACA,sBAAA;EAEA,4CAAA;EACA,gCAAA;EACA,2BAAA;EACA,oCAAA;EACA,kCAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AAAJ;AAEI;EACI,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,mBAAA;AAAR;AAGI;EApBJ;IAqBQ,8BAAA;IACA,8BAAA;IACA,8BAAA;EAAN;AACF;AAGI;EACI,mDAAA;EACA,uBAAA;EACA,oCAAA;EACA,iDAAA;AADR;AAII;EACI,iCAAA;EACA,sBAAA;EACA,iCAAA;AAFR;AAKI;EACI,oCAAA;EACA,sBAAA;EACA,oCAAA;AAHR;AAMI;EACI,oCAAA;EACA,sBAAA;EACA,oCAAA;AAJR;AAOI;EACI,mDAAA;EACA,sBAAA;EACA,oCAAA;AALR;AAQI;EACI,oCAAA;EACA,sBAAA;EACA,oCAAA;AANR;AASI;EACI,iCAAA;EACA,+CAAA;EACA,0DAAA;AAPR;;AAWA;EACI,yBAAA;EACA,8BAAA;EACA,wCAAA;AARJ;AAUI;EACI,yBAAA;AARR;AAWI;EACI,sBAAA;AATR;AAYI;EACI,sBAAA;AAVR;AAaI;EACI,yBAAA;AAXR;AAcI;EACI,yBAAA;AAZR;AAeI;EACI,sBAAA;AAbR;AAgBI;EACI,+CAAA;AAdR;;AAkBA;EACI,yBAAA;EACA,8BAAA;AAfJ;;AAkBA;EACI,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,mBAAA;AAfJ","sourcesContent":[".super-pickem-traditional-card-container {\n    min-width: 375px;\n    width: 100%;\n    border-top: 2px solid #002129;\n    border-bottom: 2px solid #002129;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin-top: 40px;\n    max-width: 550px !important; /* Removed quotes */\n    margin: 0 auto; /* Removed quotes */\n    margin-bottom: 40px;\n\n    @media (min-width: 560px) {\n        border: 2px solid #002129;\n        \n    }\n}\n\n.super-pickem-traditional-teams-container {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start;\n    justify-content: center;\n    width: 60%;\n}\n\n.super-pickem-traditional-teams {\n    height: 36px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-left: 4px;\n    width: 100%;\n}\n\n.super-pickem-traditional-at-symbol-container {\n    height: 14px;\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n\n.super-pickem-traditional-header-date {\n    color: #FFF;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    line-height: 150% !important;\n    letter-spacing: 0px !important;\n    font-size: clamp(12px, 2vw, 16px) !important;\n\n    @media (min-width: 768px) {\n        font-size: 16px !important;\n    }\n}\n\n.super-pickem-traditional-header-bet-types {\n    color: #FFF !important;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    line-height: 150% !important;\n    letter-spacing: 0px !important;\n    font-size: clamp(12px, 2vw, 16px) !important; /* Responsive font size */\n    flex: 1 !important;\n    text-align: center !important;\n\n    @media (min-width: 768px) {\n        font-size: 16px !important; /* Lock font size at 16px when screen width is 768px or more */\n    }\n}\n\n\n.super-pickem-traditional-team-logo {\n    width: clamp(20px, 4vw, 28px) !important; // Responsive width that scales from 16px to 24px based on viewport width\n    height: clamp(20px, 4vw, 28px) !important; // Responsive height that scales from 16px to 24px based on viewport width\n    object-fit: contain !important;\n}\n\n\n.super-pickem-traditional-team-name {\n    color: #002129!important;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n    white-space: nowrap !important; // Prevent text from wrapping\n    font-size: clamp(10px, 3vw, 16px) !important; // Responsive font size that scales from 10px to 16px based on viewport width\n    flex-grow: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: left;\n\n    @media (min-width: 768px) {\n        font-size: 16px !important; // Lock font size at 16px when screen width is 768px or more\n    }\n}\n\n.super-pickem-traditional-team-score {\n    text-align: right;\n    font-size: 18px !important;\n    font-weight: 700 !important;\n}\n\n.super-pickem-traditional-at-symbol {\n    color: #002129 !important;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 800 !important;\n    font-size: clamp(12px, 2vw, 14px) !important; // Responsive font size\n    margin-left: 4px !important;  // Space between the line and the @ symbol\n    margin-right: 4px !important;  // Space between @ symbol and the line\n}\n\n.super-pickem-traditional-bet-buttons-container {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    width: 40%;\n}\n\n.super-pickem-traditional-bet-button {\n    height: 40px !important;\n    width: 100% !important; // Full width of its container\n    //margin-bottom: 2px !important;\n    font-size: clamp(12px, 2vw, 14px) !important; // Responsive font size\n    white-space: pre-line !important; // Multi-line on small screens\n    line-height: 1.2 !important; // Adjust line height for multi-line text\n    border: 1px solid #002129 !important; // Border color and width\n    background-color: white !important; // Background color\n    display: flex !important; // Ensure flex properties are applied\n    align-items: center !important; // Align items center vertically\n    justify-content: center !important; // Center items horizontally\n\n    & span {\n        display: inline-flex !important;\n        flex-direction: column !important; // Stack text on small screens\n        align-items: center !important; // Align juice next to the line\n        gap: 3px !important; // Space between line and juice on larger screens\n    }\n\n    @media (min-width: 600px) {\n        white-space: nowrap !important; // Single line on larger screens\n        line-height: normal !important; // Adjust line height for single-line text\n        flex-direction: row !important; // Inline text on larger screens\n    }\n\n    // Add styles for the active state\n    &.active {\n        background-color: #00AAD133 !important; // Example active background color\n        color: white !important; // Example active text color\n        border: 1px solid #00AAD1 !important; // Example border color for active state\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2) !important; // Optional: shadow effect for active state\n    }\n\n    &.inactive {\n        background-color: #fff !important; // Example inactive background color\n        color: #fff !important; // Example inactive text color\n        border: 1px solid #fff !important; // Example border color for inactive state\n    }\n\n    &.locked {\n        background-color: #002129 !important; // Example locked background color\n        color: #fff !important; // Example locked text color\n        border: 1px solid #002129 !important; // Example border color for locked state\n    }\n\n    &.winner {\n        background-color: #CCFFEF !important; // Example winner background color\n        color: #fff !important; // Example winner text color\n        border: 1px solid #00AA72 !important; // Example border color for winner state\n    }\n\n    &.loser {\n        background-color: #CC293C33 !important; // Example loser background color\n        color: #fff !important; // Example loser text color\n        border: 1px solid #CC293C !important; // Example border color for loser state\n    }\n\n    &.push {\n        background-color: #5A5B5C !important; // Example push background color\n        color: #fff !important; // Example push text color\n        border: 1px solid #000000 !important; // Example border color for push state\n    }\n\n    &.not-chosen {\n        background-color: #fff !important; // Example not selected background color\n        color: #00212980 !important; // Example not selected text color\n        border: 1px solid #00212980 !important; // Example border color for not selected state\n    }\n}\n\n.super-pickem-traditional-bet-button-text1 {\n    color: #002129 !important; // Text color\n    white-space: nowrap !important; // Prevent text from wrapping\n    background-color: transparent !important; // Transparent background color\n\n    &.active {\n        color: #002129 !important; // Example active text color\n    }\n\n    &.inactive {\n        color: #fff !important; // Example inactive text color\n    }\n\n    &.locked {\n        color: #fff !important; // Example locked text color\n    }\n\n    &.winner {\n        color: #002129 !important; // Example winner text color\n    }\n\n    &.loser {\n        color: #002129 !important; // Example loser text color\n    }\n\n    &.push {\n        color: #fff !important; // Example push text color\n    }\n\n    &.not-chosen {\n        color: #00212980  !important; // Example not selected text color\n    }\n}\n\n.super-pickem-traditional-bet-button-text2 {\n    color: #00AAD1 !important; // Text color\n    white-space: nowrap !important; // Prevent text from wrapping\n}\n\n.super-pickem-traditional-button-pair {\n    display: flex !important;\n    flex-direction: column !important; // Stack buttons vertically\n    align-items: center !important; // Center buttons horizontally\n    gap: 2px !important; // Space between buttons\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
